"use client";

import { useEffect, useRef } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import useMobile from "@/app/lib/features/mobile/mobile.hook";
import { MobileMessageData } from "@/app/lib/features/mobile/mobile.types";
import useAuth from "@/app/lib/features/auth/auth.hook";
import { setMobileTokenAccessor } from "@/app/lib/storeAccessor";

// MobileTokenInitializer — useSearchParams kullanır, children sarmaz
// MountedProvider'da ayrı Suspense içine alınır, böylece suspend olunca children etkilenmez
export const MobileTokenInitializer = () => {
  const { updateIsPurePage, updateIsMobileAi, updateMobileToken } = useMobile();
  const { userProfile, fetchUserProfile } = useAuth();
  const userProfileRef = useRef(userProfile);
  useEffect(() => { userProfileRef.current = userProfile; }, [userProfile]);

  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const queryToken = searchParams.get("token");
    if (!queryToken) return;

    updateMobileToken(queryToken);
    setMobileTokenAccessor(queryToken);
    if (!userProfileRef.current) {
      fetchUserProfile();
    }

    const params = new URLSearchParams(searchParams.toString());
    params.delete("token");
    const clean = params.size > 0 ? `${pathname}?${params}` : pathname;
    router.replace(clean);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data as MobileMessageData;

      if (typeof data.token === "string" && data.token) {
        updateMobileToken(data.token);
        setMobileTokenAccessor(data.token);
        if (!userProfileRef.current) {
          fetchUserProfile();
        }
      }

      if (typeof data.pure_page === "boolean") {
        updateIsPurePage(data.pure_page);
      }

      if (typeof data.mobile_ai === "boolean") {
        updateIsMobileAi(data.mobile_ai);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [fetchUserProfile, updateIsPurePage, updateIsMobileAi, updateMobileToken]);

  return null;
};

export const MobileTokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;
